<template>
  <v-btn
    absolute
    top
    fab
    x-small
    style="right: -15px"
    color="grey lighten-4"
    dark
    @click="emitOnClick"
  >
    <v-icon color="red">
      mdi-trash-can-outline
    </v-icon>
  </v-btn>
</template>

<script>
  export default {
    name: 'NodeDeleteButton',
    methods: {
      emitOnClick () {
        this.$emit('onClick')
      }
    },
  }
</script>

<style scoped>

</style>
